export const PathName = {
	DASHBOARD: "/",
	LOGIN: "/login",
	DEMO: "/mcd-demo",
	FLASHCARDS: "/mcd-flashcards",
	INFO: "/mcd-info",
	LAYGO: "/mcd-laygo",
	NUMBERS: "/mcd-numbers",
	OPS: "/mcd-ops",
	PATHS: "/mcd-paths",
	RESOURCES: "/mcd-resources",
	SEARCH: "/mcd-search",
	WHATS_NEW: "/?p=whats-new",
	MY_SETTINGS_UPDATE: "/?p=my-settings-update",
	MY_SETTINGS: "/?p=my-settings",
	CHECKLISTS: "/mcd-checklists",
	CHECKLIST: function (checklistAssignmentId: string) {
		return (
			this.CHECKLISTS + (checklistAssignmentId !== undefined ? `/${checklistAssignmentId}` : "")
		);
	},
	CHECKLIST_REPORTS: "/mcd-checklists/reports",
	CHECKLIST_REPORT: function (checklistReportId: string) {
		return (
			this.CHECKLIST_REPORTS + (checklistReportId !== undefined ? `/${checklistReportId}` : "")
		);
	},
	FORMS: function (formId?: string) {
		return `/mcd-forms${formId !== undefined ? `/${formId}` : ""}`;
	},
	FORM_BUILDER: "/form-builder",
	FORM_BUILDER_FORMS: "/form-builder/forms",
	FORM_BUILDER_FORMS_ADD: "/form-builder/forms/add",
	FORM_BUILDER_FORMS_EDIT: function (formId?: string) {
		return `/form-builder/forms/${formId !== undefined ? formId : ":formId"}`;
	},
	FORM_BUILDER_SELECTS: "/form-builder/selects",
	FORM_BUILDER_SELECTS_ADD: "/form-builder/selects/add",
	FORM_BUILDER_SELECTS_EDIT: function (selectId?: string) {
		return `/form-builder/selects/${selectId !== undefined ? selectId : ":selectId"}`;
	},
	// FORM_ORGANIZATIONS: function (formId: string, organizationId?: string) {
	// 	return `${this.FORMS(formId)}/organizations${
	// 		organizationId !== undefined ? `/${organizationId}` : ""
	// 	}`;
	// },
	// FORM_ORGANIZATION_SUBMISSIONS: function (
	// 	formId: string,
	// 	organizationId: string,
	// 	submissionId?: string,
	// ) {
	// 	return `${this.FORM_ORGANIZATIONS(formId, organizationId)}/submissions${
	// 		submissionId !== undefined ? `/${submissionId}` : ""
	// 	}`;
	// },
	// FORM_ORGANIZATION_SUBMISSIONS_ADD: function (formId: string, organizationId: string) {
	// 	return `${this.FORM_ORGANIZATIONS(formId, organizationId)}/submissions/add`;
	// },
};

export const imgPath = "https://files-cdn.nuggetkms.com/nuggetkms/images";
export const mediaPath = "https://files-cdn.nuggetkms.com";
export const docPath = "https://files-cdn.nuggetkms.com/documents";
export const videoPath = "https://files-cdn.nuggetkms.com/video";
export const mediaImgPath = "https://files-cdn.nuggetkms.com/images";
